import { HeadlineVariation } from '@allesauto/utils/consts';
import clsx from 'clsx';
import React, { FC } from 'react';

export interface HeadlineProps {
  headlineText: string;
  headlineColor?: string;
  descriptionText?: string;
  headlineTag: HeadlineVariation;
  headlineClassName?: string;
  className?: string;
  descriptionColor?: string;
  descriptionTextPreApprovalForm?: string | undefined;
}

const Headline: FC<HeadlineProps> = (props: HeadlineProps) => {
  const {
    headlineText,
    descriptionText,
    headlineTag = HeadlineVariation.H1,
    headlineColor = 'text-grey100',
    headlineClassName = `text-headline${headlineTag}`,
    className: customClassName,
    descriptionColor = 'text-grey60',
    descriptionTextPreApprovalForm,
    ...restProps
  } = props;

  const className = {
    headlineTextClass: clsx(
      'font-headline font-weight-bold',
      descriptionText && 'pb-15px',
      headlineColor,
      headlineClassName,
      customClassName
    ),
    descriptionTextClass: clsx(
      'font-regular font-weight-normal text-p1',
      descriptionColor,
      descriptionTextPreApprovalForm && 'mt-[16px]'
    ),
  };
  const HeadlineElement = `h${headlineTag}` as keyof JSX.IntrinsicElements;

  return (
    <>
      <HeadlineElement className={className.headlineTextClass} {...restProps}>
        {headlineText}
        {descriptionTextPreApprovalForm && (
          <p
            dangerouslySetInnerHTML={{
              __html: descriptionTextPreApprovalForm,
            }}
            className={className.descriptionTextClass}
          ></p>
        )}
      </HeadlineElement>
      {descriptionText && (
        <p
          dangerouslySetInnerHTML={{
            __html: descriptionText,
          }}
          className={className.descriptionTextClass}
        ></p>
      )}
    </>
  );
};

export default Headline;
